function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { spacing } from '@naf/theme';
export const Form = /*#__PURE__*/forwardRef(({
  direction = 'horizontal',
  formStyle,
  children,
  className,
  ...rest
}, ref) => {
  return /*#__PURE__*/React.createElement(StyledForm, _extends({
    $direction: direction,
    className: className,
    ref: ref,
    style: formStyle
  }, rest), children);
});
export default Form;
const StyledForm = styled.form.withConfig({
  displayName: "form__StyledForm",
  componentId: "sc-c5oi9v-0"
})(["display:flex;flex-wrap:wrap;", ";", ";"], ({
  $direction
}) => $direction === 'horizontal' && css(["flex-direction:row;> div:not(:last-child){margin-right:", ";}> span:last-child{margin-top:", ";}"], spacing.space24, spacing.space12), ({
  $direction
}) => $direction === 'vertical' && css(["flex-direction:column;> div:not(:first-of-type){margin-top:", ";}> span:last-child{margin-top:", ";}"], spacing.space12, spacing.space12));
//# sourceMappingURL=form.js.map